<script setup lang="ts">
import { RowInfo } from '@shared/ui/other'

import { useMainInfoVideoRecordings } from '../../model/main-info-video-recordings.hook'

defineOptions({
  name: 'MainInfoVideoRecordings',
})

const { refValue } = useMainInfoVideoRecordings()
</script>

<template>
  <RowInfo
    title="Video Recordings"
    :value="refValue"
  />
</template>
